export default __webpack_public_path__ + "static/media/moldex.cd4bea8c.svg";